export const getUserDisplayName = (user) => {
    const fn = user?.first_name?.toString().trim();
    const ln = user?.last_name?.toString().trim();
    const chunks = [fn, ln].filter(x => x && x.length > 0);
    return chunks.join(' ');
}

const isEmailValid = (email) => {
    return true;
}

const isPhoneValid = (phone) => {
    return true;
}

export const participantHasRequiredFields = (participant) => {
    if (!participant) { return false; }
    if (!participant.user) { return false; }
    if (!participant.user.first_name || (participant.user.first_name.toString().trim().length <= 0)) { return false; }
    if (!participant.user.last_name || (participant.user.last_name.toString().trim().length <= 0)) { return false; }
    if (!participant.user.email || (participant.user.email.toString().trim().length <= 0) || !isEmailValid(participant.user.email)) { return false; }
    if (!participant.user.phone || (participant.user.phone.toString().trim().length <= 0) || !isPhoneValid(participant.user.phone)) { return false; }
    return true;
    // TODO: refactor to add email and phone validation, and name length checks
    // return participant && participant.user && participant.user.first_name && participant.user.last_name && participant.user.email && participant.user.phone;
}

export const participantSignedAllWaivers = (participant, waivers) => {
    const waiverIds = [];
    (waivers || []).map(w => waiverIds.push(w.id));
    const ws = participant.waiver_signatures || [];
    const nSignatures = ws.filter(x => waiverIds.indexOf(x.waiver) >= 0).length;
    return ws.length >= waiverIds.length && nSignatures >= waiverIds.length;
}

export const getCheckedInFlag = (participant, waivers) => {
    const hasUserDetails = participantHasRequiredFields(participant);
    const signedAllWaivers = participantSignedAllWaivers(participant, waivers);
    return hasUserDetails && signedAllWaivers;
}

export const getParticipantsFromBooking = (booking, waivers) => {
    const b = {
        ...booking,
        display_name: getUserDisplayName(booking.user),
        checked_in: getCheckedInFlag(booking, waivers),
        lang: booking.user?.lang || 'en',
    };
    const participants = [b];
    Array.from(Array(booking.people_count - 1)).map((_, subidx) => {
        const sub = subidx < (booking.party || []).length ? booking.party[subidx] : {};
        if (!sub.id) {
            sub.id = -subidx;
        }
        sub.rowIdx = subidx + 2;
        sub.display_name = getUserDisplayName(sub.user);
        sub.checked_in = getCheckedInFlag(sub, waivers);
        sub.lang = sub.user?.lang || 'en';
        participants.push(sub);
    });
    return participants;
}

// Utility functions for booking management

/**
 * Get all participants with booking.user as Lead Booker and booking.party as guests
 * @param {Object} booking - The booking object
 * @returns {Array} Array of all participants where index 0 is Lead Booker (booking.user)
 */
export const getAllParticipants = (booking) => {
    if (!booking) return [];

    const leadBooker = {
        id: booking.user?.id,
        user: booking.user,
        // These fields should already be mapped by alignBookingData, fallback to user if not
        passport_number: booking.passport_number || booking.user?.passport_number || '',
        emergency_contact: booking.emergency_contact || booking.user?.emergency_contact || '',
        custom_note: booking.custom_note || booking.user?.custom_note || '',
        is_minor: booking.is_minor !== undefined ? booking.is_minor : (booking.user?.is_minor || false),
        notes: booking.notes || booking.user?.notes || '',
        tags: booking.tags || booking.user?.tags || [],
        waiver_signatures: booking.waiver_signatures || booking.user?.waiver_signatures || [],
        pricing: booking.pricing || booking.user?.pricing || [],
        guidelanguage: booking.guidelanguage || booking.user?.guidelanguage || [],
        // Answers to the operator's custom fields (party entries carry their own)
        precheckin_answers: booking.precheckin_answers || {}
    };

    return [leadBooker, ...(booking.party || [])];
};

/**
 * Get participant by index where 0 is Lead Booker
 * @param {Object} booking - The booking object
 * @param {number} index - The participant index
 * @returns {Object|null} The participant at the given index
 */
export const getParticipantByIndex = (booking, index) => {
    const allParticipants = getAllParticipants(booking);
    return allParticipants[index] || null;
};

/**
 * Check if participant is Lead Booker
 * @param {number} index - The participant index
 * @returns {boolean} True if participant is Lead Booker
 */
export const isLeadBooker = (index) => {
    return index === 0;
};

/**
 * Get total number of participants (Lead Booker + guests)
 * @param {Object} booking - The booking object
 * @returns {number} Total number of participants
 */
export const getTotalParticipants = (booking) => {
    if (!booking) return 0;
    // party already includes virtual participants (added by alignBookingData based on people_count)
    return 1 + (booking.party?.length || 0); // 1 (Lead Booker) + guests (including virtual)
};

/**
 * How many participant form steps exist in pre-check-in UI (lead + guests).
 * When collect_party_members_info is false, only the lead is collected; virtual party slots are ignored.
 */
export const getParticipantStepCount = (booking, preCheckSettings) => {
    if (!booking) return 0;
    if (preCheckSettings?.collect_party_members_info === false) {
        return 1;
    }
    return getTotalParticipants(booking);
};
